import { ObservableArray, View } from "binder"
import { ServerSideDataLoader } from "uicomponents";
import { WarehouseSelectorViewModel } from "../warehouseManipulation/warehouseManipulation-viewModel";
import { lineItem, SetInitialBalanceViewModel } from "./setInitialBalance-viewModel"

export class SetInitialBalanceView extends View<SetInitialBalanceViewModel>{
    GetViewUniqueId(): string {
        return "V-286F391B-49C2-4AF9-A9EC-AB9BBF0B2D75"
    }
    loadHtml(): string {
        let element = require('./setInitialBalance.html').default;
        let style = require('./setInitialBalance.less');
        return element;
    }
    constructor() {
       super();
    }
    public set warehouseSelector(v: WarehouseSelectorViewModel) { this._warehouseSelector = v; } public get warehouseSelector(): WarehouseSelectorViewModel { return this._warehouseSelector;} private _warehouseSelector: WarehouseSelectorViewModel;
    public set warehouseName(v: string) { this._warehouseName = v; } public get warehouseName(): string { return this._warehouseName;} private _warehouseName: string;
    public set warehouseId(v: string) { this._warehouseId = v; } public get warehouseId(): string { return this._warehouseId;} private _warehouseId: string;
    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader;} private _loader: ServerSideDataLoader;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set lineItems(v: ObservableArray<lineItem>) { this._lineItems = v; } public get lineItems(): ObservableArray<lineItem> { return this._lineItems;} private _lineItems: ObservableArray<lineItem>;

}

